import api from '@/configs/ApiConfig';
const Plan = () => import(/* webpackChunkName: "plan" */ '@/views/journals/plan/Plan.vue');
const Schedule = () => import(/* webpackChunkName: "schedule" */ '@/views/journals/schedule/Schedule.vue');
const PlanEdit = () => import(/* webpackChunkName: "planEdit" */ '@/views/journals/planEdit/PlanEdit.vue');

const Order = () => import(/* webpackChunkName: "order" */ '@/views/journals/order/Order.vue');

const PlywoodPriceList = () =>
    import(/* webpackChunkName: "plywoodPriceList" */ '@/views/journals/plywoodPriceList/PlywoodPriceList.vue');

const ScheduleEquipmentActivity = () =>
    import(
        /* webpackChunkName: "scheduleEquipmentActivity" */ '@/views/journals/scheduleEquipmentActivity/ScheduleEquipmentActivity.vue'
    );

const warehousePlywoodState = () =>
    import(
        /* webpackChunkName: "warehousePlywoodState" */ '@/views/journals/warehousePlywoodState/WarehousePlywoodState.vue'
    );

const warehousePlywoodAudit = () =>
    import(
        /* webpackChunkName: "warehousePlywoodAudit" */ '@/views/journals/warehousePlywoodAudit/WarehousePlywoodAudit.vue'
    );

const warehouseVeneerState = () =>
    import(
        /* webpackChunkName: "warehouseVeneerState" */ '@/views/journals/warehouseVeneerState/WarehouseVeneerState.vue'
    );

const warehouseVeneerAudit = () =>
    import(
        /* webpackChunkName: "warehouseVeneerAudit" */ '@/views/journals/warehouseVeneerAudit/WarehouseVeneerAudit.vue'
    );

export default [
    {
        name: 'plan',
        path: api.journals.plan,
        component: Plan,
    },
    {
        name: 'schedule',
        path: api.journals.schedule,
        component: Schedule,
    },
    {
        name: 'planEdit',
        path: '/planedit/:idPlan',
        component: PlanEdit,
        props: true,
        children: [
            {
                path: 'settings',
                component: () => import('@/views/journals/planEdit/planEditTabs/settings/PlanEditSettings.vue'),
                props: true,
            },
            {
                path: 'shift',
                component: () => import('@/views/journals/planEdit/planEditTabs/shift/PlanEditShift.vue'),
                props: true,
            },
            {
                path: 'equipment',
                component: () => import('@/views/journals/planEdit/planEditTabs/equipment/PlanEditEquipment.vue'),
                props: true,
            },
            {
                path: 'warehouseveneer',
                component: () =>
                    import('@/views/journals/planEdit/planEditTabs/warehouseVeneer/PlanEditWarehouseVeneer.vue'),
                props: true,
                children: [
                    {
                        path: '',
                        component: () =>
                            import(
                                '@/views/journals/planEdit/planEditTabs/warehouseVeneer/PlanEditWarehouseVeneerFlexGrid.vue'
                            ),
                        props: true,
                    },
                    {
                        path: ':idWarehouseVeneer',
                        component: () =>
                            import(
                                '@/views/journals/planEdit/planEditTabs/warehouseVeneer/PlanEditWarehouseVeneerFlexGrid.vue'
                            ),
                        props: true,
                    },
                ],
            },
            {
                path: 'warehouseplywood',
                component: () =>
                    import('@/views/journals/planEdit/planEditTabs/warehousePlywood/PlanEditWarehousePlywood.vue'),
                props: true,
                children: [
                    {
                        path: '',
                        component: () =>
                            import(
                                '@/views/journals/planEdit/planEditTabs/warehousePlywood/PlanEditWarehousePlywoodFlexGrid.vue'
                            ),
                        props: true,
                    },
                    {
                        path: ':idWarehousePlywood',
                        component: () =>
                            import(
                                '@/views/journals/planEdit/planEditTabs/warehousePlywood/PlanEditWarehousePlywoodFlexGrid.vue'
                            ),
                        props: true,
                    },
                ],
            },
            {
                path: 'plywoodorder',
                component: () => import('@/views/journals/planEdit/planEditTabs/plywoodOrder/PlanEditPlywoodOrder.vue'),
                props: true,
            },
            {
                path: 'result',
                alias: 'result/*',
                component: () => import('@/views/journals/planEdit/planEditTabs/result/PlanEditResult.vue'),
                props: true,
            },
        ],
    },
    {
        name: 'order',
        path: api.journals.order,
        component: Order,
    },
    {
        name: 'plywoodPriceList',
        path: api.journals.plywoodPriceList,
        component: PlywoodPriceList,
    },
    {
        name: 'scheduleEquipmentActivity',
        path: api.journals.scheduleEquipmentActivity,
        component: ScheduleEquipmentActivity,
    },
    {
        name: 'warehousePlywoodState',
        path: api.journals.warehousePlywoodState,
        component: warehousePlywoodState,
    },
    {
        name: 'warehousePlywoodAudit',
        path: api.journals.warehousePlywoodAudit,
        component: warehousePlywoodAudit,
    },
    {
        name: 'warehouseVeneerState',
        path: api.journals.warehouseVeneerState,
        component: warehouseVeneerState,
    },
    {
        name: 'warehouseVeneerState',
        path: api.journals.warehouseVeneerAudit,
        component: warehouseVeneerAudit,
    },
];
